module.exports = __webpack_public_path__ + "static/img/timeIcon.0053894d.png";